import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html'
})
export class AlertModalComponent {
  title: string;
  message: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: AlertModalComponent) {
    this.title = data.title;
    this.message = data.message;
  }
}
